import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDevRuntimeStore } from '@modules/dev/devRuntime';

export function useDevMode(): boolean {
  const location = useLocation();
  const setEnabled = useDevRuntimeStore((state) => state.setEnabled);

  const enabled = useMemo(() => {
    // The dev dock shows up only when the URL carries ?dev=1 — nothing else.
    const search = new URLSearchParams(location.search);
    return search.get('dev') === '1';
  }, [location.search]);

  useEffect(() => {
    setEnabled(enabled);
  }, [enabled, setEnabled]);

  return enabled;
}
